import Vue from 'vue'
import * as Sentry from '@sentry/vue'
import { mapGetters } from 'vuex'
import CategoryApi from '@/api/category'

export default (TemplateLibrary) => Vue.component('TemplateLibraryContainer', {
  data() {
    return {
      categories: [],
    }
  },
  computed: {
    ...mapGetters('templates', [
      'getDiscoverTemplates',
    ]),
    normalizedTemplates() {
      const data = this.getDiscoverTemplates || []

      return data.map((t) => ({
        ...t,
        copyCount: t.downloadCount || t.copyCount,
        isStaffPick: t.isStaffPick || t.isAdminPick,
      }))
    },
  },
  async created() {
    await this.getAllCategories()
    await this.initDiscoverTemplates()
  },
  methods: {
    async getAllCategories() {
      try {
        const res = await CategoryApi.getAllCategoriesV2({
          sortBy: 'order',
          sortDesc: false,
        })
        this.categories = res && res.data
      } catch (e) {
        Sentry.captureException(e)
      }
    },
    async initDiscoverTemplates() {
      await this.$store.dispatch('templates/fetchDiscoverTemplates')
    },
  },
  render(createElement) {
    return createElement(TemplateLibrary, {
      props: {
        categories: this.categories,
        featuredTemplatesByCategories: this.normalizedTemplates,
      },
    })
  },
})
